/**
 * Linear scanner for lowercase {{ai}} / {{ai: hint}} blocks. Keep the server,
 * async worker and SPA copies in sync: each is shipped in a separate bundle.
 * Hints may contain opening braces; the first closing brace must begin "}}".
 */
export function* iterateAiBlocks(text) {
    let cursor = 0;
    while (cursor < text.length) {
        const start = text.indexOf('{{', cursor);
        if (start === -1) return;
        let at = start + 2;
        while (at < text.length && /\s/.test(text[at])) at++;
        if (!text.startsWith('ai', at)) {
            cursor = start + 1;
            continue;
        }
        at += 2;
        while (at < text.length && /\s/.test(text[at])) at++;
        let hintStart = at;
        let close = at;
        if (text[at] === ':') {
            hintStart = at + 1;
            close = text.indexOf('}', hintStart);
            if (close === -1) return;
            // Every opener inside this hint sees the same first closing brace.
            // If it is single, none can match before it; skip it once.
            cursor = close + 1;
        } else {
            cursor = start + 1;
        }
        if (text[close] !== '}' || text[close + 1] !== '}') continue;
        const end = close + 2;
        yield { start, end, raw: text.slice(start, end), hint: text.slice(hintStart, close).trim() };
        cursor = end;
    }
}

/** Splice callbacks into the original, nonoverlapping raw block spans. */
export function replaceAiBlocks(text, replacement) {
    const parts = [];
    let cursor = 0;
    for (const block of iterateAiBlocks(text)) {
        parts.push(text.slice(cursor, block.start), replacement(block));
        cursor = block.end;
    }
    parts.push(text.slice(cursor));
    return parts.join('');
}
